<template>
  <div
    v-if="visible"
    class="preview-image-container"
  >
    <div
      class="image-wrapper"
      :class="{ 'pcMode': pcMode }"
    >
      <img
        class="image"
        :src="imageList[currentIndex]"
        alt=""
      >
      <div
        @click="handleClose"
        class="close-icon"
      >
        <img
          src="@/assets/images/close-icon.svg"
          alt=""
        >
      </div>
      <div class="point">
        <img
          @click="handlePrev"
          class="arrow left"
          :class="{ disabled: currentIndex === 0 }"
          src="@/assets/order/preview-image-arrow.svg"
          alt=""
        >
        <div class="indicator">
          {{ currentIndex + 1 }} / {{ imageList.length }}
        </div>
        <img
          @click="handleNext"
          class="arrow"
          :class="{ disabled: currentIndex + 1 === imageList.length }"
          src="@/assets/order/preview-image-arrow.svg"
          alt=""
        >
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'

const visible = defineModel({ required: true, default: false })

const props = defineProps({
  imageList: {
    type: Array,
    default: () => []
  }
})

watch(visible, (value) => {
  if (value) {
    getImageSize()
    document.body.style = 'overflow: hidden;'
  } else {
    document.body.style = ''
  }
})

const currentIndex = ref(0)

const pcMode = ref(false)

const handleClose = () => {
  visible.value = false
}

const handlePrev = () => {
  if (currentIndex.value === 0) return
  currentIndex.value--
  getImageSize()
}

const handleNext = () => {
  if (currentIndex.value + 1 === props.imageList.length) return
  currentIndex.value++
  getImageSize()
}

const getImageSize = () => {
  const url = props.imageList[currentIndex.value]

  const img = new Image()
  img.src = url

  img.onload = () => {
    const width = img.width
    const height = img.height
    pcMode.value = height / width < 2
  }
}

</script>

<style lang='less' scoped>
.preview-image-container {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, .64);
  backdrop-filter: blur(8px);
  z-index: 9999;

  .image-wrapper {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 360px;
    height: 640px;
    transform: translate(-50%, -50%);
    background-color: black;
    transition: all, .3s ease-in-out;

    &.pcMode {
      width: 960px;
      height: 540px;
    }

    .image {
      height: 100%;
      width: 100%;
      border: 4px solid white;
      object-fit: contain;
    }

    .close-icon {
      position: absolute;
      top: 6px;
      left: calc(100% + 8px);
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      border-radius: 50%;
      transition: background .3s ease-in-out;

      &:hover {
        background: rgba(255, 255, 255, .2);
      }
    }

    .point {
      position: absolute;
      left: 50%;
      bottom: -60px;
      transform: translateX(-50%);
      display: flex;
      align-items: center;
      justify-content: center;
      width: 103px;
      height: 36px;
      padding: 0 10px;
      border-radius: 18px;
      background-color: rgba(0, 0, 0, .64);

      .arrow {
        cursor: pointer;
        width: 20px;
        height: 20px;
        padding: 2px;
        border-radius: 4px;
        transition: background .3s ease-in-out;

        &:hover {
          background: rgba(255, 255, 255, .2);
        }

        &.disabled {
          opacity: .4;
        }
      }

      .left {
        transform: rotate(180deg);
      }

      .indicator {
        flex: 1;
        text-align: center;
        color: white;
        font-size: 12px;
        font-family: mon-500;
      }
    }
  }
}
</style>
